import React from 'react'
import { inject, observer } from 'mobx-react'
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import styled from 'styled-components'
import { Row, Input, message } from 'antd'
import './pushModal.scss'
import { observable, action, computed } from 'mobx'
import cx from 'classnames'
import request from "app/vendor/request"
import config from "app/config"

const LightBlueBlock = styled.div`
  background: rgb(241, 248, 255);
  padding: 12px 18px;
`

const SummaryLabel = styled.label`
  line-height: 30px;
  align-self: flex-start;
  flex-shrink: 0;
  text-align: right;
  width: 90px;
`

const BaseInfoItem = styled(Row)`
  margin-bottom: 8px;
  color: rgb(102, 102, 102);

  p {
    color: rgb(51, 51, 51);
  }

  &:last-child {
    margin-bottom: 0;
  }
`

const ExpandBtn = styled.div`
  cursor: pointer;
  margin-left: 6px;
  line-height: 12px;
  border-radius: 2px;
  padding: 3px 6px;
  color: white;
  border: none;
  font-weight: 300;

  &.extend-btn {
    background: #3171af;
  }

  &.close-btn {
    background: #aaa;
  }
`

const Line = styled.div`
  height: 1px;
  flex-grow: 1;
  background: #eeeeee;
`

const RecordWrap = styled.div`
  width: calc(100% + 18px);
  overflow-y: scroll;
  max-height: 160px;
  transition: $transtionExtend;

  &.close {
    max-height: 0;
  }
`

const HiddenScrollBar = styled.div`
  overflow: hidden;
`

const InfoBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 14px;
`

const InfoArea = styled.div`
  display: flex;
  align-items: center;
`

const RightArea = InfoArea.extend`
  font-size: 12px;
  color: rgb(153, 153, 153);
  font-family: 'PingFangSC-Light';
`

const Tag = styled.div`
  padding: 7px 24px;
  background-color: rgb(241, 248, 255);
  font-size: 14px;
  font-family: 'PingFangSC-Semibold';
  color: rgb(44, 112, 174);
  border-radius: 20px;
  line-height: 14px;
`

const GreenBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 162px;
  height: 40px;
  border-radius: 3px;
  font-size: 14px;
  background: rgb(88, 188, 0);
  margin-right: 10px;
  border: none;
  color: white;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
`

const YellowBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 162px;
  height: 40px;
  border-radius: 3px;
  font-size: 14px;
  background: #f8b62d;
  margin-right: 10px;
  border: none;
  color: white;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
`

const RecordItemContent = styled.div`
  white-space: pre-line;
  font-family: 'PingFangSC-Regular';
  line-height: 17px;
`

const RecordItemWrap = styled.div`
  padding: 0 5px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0
  }
`

@inject('auth')@observer
export default class PushModal extends React.Component {
  @observable showHistory = false
  @observable summaries = []
  @observable pushSubmitData = {
    summary: '',
    summaryGender: '',
    summaryAneu: '',
    summaryCNV: '',
  }

  @observable btnLocked = false

  isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0
  }

  componentDidMount() {
    const { detailData } = this.props.store
    this.getSummaries(detailData.reportId)
    .then(
      res => {
        this.handleDataChange()
      },
      err => {
        message.error(err.message)
      }
    )
  }

  handleDataChange = () => {
    const { detailData } = this.props.store
    // 如果返回的记录有值，用之前保存过的，否则从详情内提取
    if (detailData.dataVersion === 'v1.0') {
      this.onPushDataChange('summary',
        this.summaries[0] ?
        this.summaries[0].summary :
        `结果：${detailData.resultPos || ''}
      补充结果：${detailData.resultM || ''}`
      )
    } else {
      this.onPushDataChange('summary',
        this.summaries[0] ?
        this.summaries[0].summary :
        `${detailData.resultM || '无'}`
      )
      this.onPushDataChange('summaryGender', 
        this.summaries[0] ? 
        this.summaries[0].summaryGender: 
        `${detailData.resultGender || '未见异常'}`
      )
      this.onPushDataChange('summaryAneu',
        this.summaries[0] ? 
        this.summaries[0].summaryAneu:
        `${detailData.resultAneu || '未见异常'}`
      )
      this.onPushDataChange('summaryCNV',
        this.summaries[0] ? 
        this.summaries[0].summaryCNV:
        `${detailData.resultCNV || '未见异常'}`
      )

    }
  }

  @action getSummaries = (reportId) => {
    return request.get(`${config.backend}/pgs/reports/${reportId}/summaries`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.summaries = res
          return Promise.resolve()
        },
        err => {
          message.error(err.message)
          return Promise.reject()
        }
      )
  }

  @action onPushDataChange = (field, value) => {
    this.pushSubmitData[field] = value
  }

  @action clearPushData = () => {
    this.pushSubmitData = {
      summary: '',
      summaryGender: '',
      summaryAneu: '',
      summaryCNV: ''
    }
  }

  @action handlePush = () => {
    let {
      closeModal,
    } = this.props

    this.btnLocked = true

    if (this.isModify) { // 做过修改了先保存后提交
      this.saveReport()
        .then(
          res => {
            return this.pushReport()
          }
        ).then(
          res => {
            this.clearPushData()
            closeModal()
          }
        ).finally(
          res => this.btnLocked = false
        )
    } else { // 否则直接提交
      this.pushReport()
      .then(
        res => {
          this.clearPushData()
          closeModal()
        }
      ).finally(
        res => this.btnLocked = false
      )
    }
  }

  @action pushReport = () => {
    const {
      store: { detailData },
      groupId,
    } = this.props
    return request.post(
      `${config.backend}/pgs/reports/notice/${detailData.reportId}?` +
      `summaryId=${this.summaries[0].id}&groupId=${groupId}`
    )
      .checkToken()
      .commonDispose()
      .then(
        res => {
          message.success('报告推送成功')
          return Promise.resolve()
        },
        err => {
          message.error(err.message)
          return Promise.reject()
        }
      )
  }

  @action showHistoryReport = () => {
    this.showHistory = true
  }

  @action toggleHistoryReport = () => {
    this.showHistory = !this.showHistory
  }

  @computed get isModify ()  {
    const pushData = this.pushSubmitData
    const summarieData = this.summaries[0]
    if(summarieData) {
      const isEqualSummary = pushData.summary === summarieData.summary
      const isEqualGender = pushData.summaryGender === summarieData.summaryGender
      const isEqualAneu = pushData.summaryAneu === summarieData.summaryAneu
      const isEqualCNV = pushData.summaryCNV === summarieData.summaryCNV
      if (isEqualSummary && isEqualGender && isEqualAneu && isEqualCNV) {
        return false
      }
    }
    return true
  }

  @action saveReport = () => {
    const { detailData } = this.props.store

    this.btnLocked = true
    return request.post(`${config.backend}/pgs/reports/${detailData.reportId}/summaries`)
      .checkToken()
      .send(this.pushSubmitData)
      .commonDispose()
      .then(
        res => {
          message.success('报告结论保存成功')
          return this.getSummaries(detailData.reportId)
        },
        err => {
          message.error(err.message)
          return Promise.reject(err)
        }
      ).finally(
        res => this.btnLocked = false
      )
  }

  renderVersionOne = () => {
    return (
      <Row style={{ flexWrap: 'nowrap', marginTop: 20 }} type='flex' align='middle' justify=''>
        <SummaryLabel>报告结论：</SummaryLabel>
        <Input
          autosize={true}
          style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
          placeholder='请输入报告结论'
          type='textarea'
          value={this.pushSubmitData.summary}
          onChange={(e) => this.onPushDataChange('summary', e.target.value)}
        />
      </Row>
    )
  }
  renderVersionTwo = () => {
    return (
      <div>
        <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>性染色体：</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder='请输入染色体结论'

            type='textarea'
            value={this.pushSubmitData.summaryGender}
            onChange={(e) => this.onPushDataChange('summaryGender', e.target.value)}
          />
        </Row>
        <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>整倍体：</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8}}
            placeholder='请输入整倍体结论'
            type='textarea'
            value={this.pushSubmitData.summaryAneu}
            onChange={(e) => this.onPushDataChange('summaryAneu', e.target.value)}
          />
        </Row>
        <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>CNV：</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder='请输入CNV结论'
            type='textarea'
            value={this.pushSubmitData.summaryCNV}
            onChange={(e) => this.onPushDataChange('summaryCNV', e.target.value)}
          />
        </Row>
        <Row style={{ flexWrap: 'nowrap', marginTop: 10 }} type='flex' align='middle' justify=''>
          <SummaryLabel>补充结果：</SummaryLabel>
          <Input
            autosize={true}
            style={{ maxHeight: 86, lineHeight: '17px', fontFamily: 'PingFangSC-Regular', padding: 8 }}
            placeholder='请输入补充结果结论'
            type='textarea'
            value={this.pushSubmitData.summary}
            onChange={(e) => this.onPushDataChange('summary', e.target.value)}
          />
        </Row>
      </div>
    )
  }
  render() {
    let {
      data = {},
      closeModal,
      store: { detailData }
    } = this.props
    const { showHistory } = this
    const extendBtnClass = cx({
      "close-btn": showHistory,
      "extend-btn": !showHistory
    })
    const RecordWrapClass = cx({
      "push-record-table": true,
      "close": !showHistory,
    })
    return (
      <MaterialModal
        wrapClassName='push-modal-wrap'
        draggable={true}
        className="push-modal"
        title="报告推送"
        visible={true}
        width={800}
        mask={false}
        footer={(
          <Row type='flex' align='middle' justify='center'>
            <YellowBtn
              onClick={() => {
                this.isModify ? !this.btnLocked && this.saveReport() : message.error('请在修改报告结论后保存')
              }}
            >
              保存结果
            </YellowBtn>
            <GreenBtn
              onClick={!this.btnLocked && this.handlePush}
            >
              推送报告至Lims
            </GreenBtn>
          </Row>
        )}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={()=> {
            closeModal()
            this.clearPushData()
          }}
        />
        <LightBlueBlock>
          <BaseInfoItem type='flex' align='middle' justify=''>
            <label>文件名称：</label>
            <p>{!this.isEmptyObj(detailData) ? detailData.dataName : ""}</p>
          </BaseInfoItem>
          <BaseInfoItem type='flex' align='middle' justify=''>
            <label>所在分组：</label>
            <p>{data.groupName}</p>
          </BaseInfoItem>
          <BaseInfoItem type='flex' align='middle' justify=''>
            <label>样本名称：</label>
            <p>{!this.isEmptyObj(detailData) ? detailData.sampleName : []}</p>
          </BaseInfoItem>

        </LightBlueBlock>
        
        {detailData.dataVersion === 'v1.0' ? this.renderVersionOne() : this.renderVersionTwo()}
        
        <Row style={{ marginTop: 20 }} type='flex' justify='start' align='middle' className='subtitle history'>
          <i></i>
          <b>历史记录（{this.summaries.length}条）</b>
          <Line></Line>
          <ExpandBtn onClick={this.toggleHistoryReport} className={extendBtnClass}>
            {showHistory ? "收起" : "展开"}
          </ExpandBtn>
        </Row>

        <HiddenScrollBar>
          <RecordWrap className={RecordWrapClass}>
            {
              this.summaries.map((item) => {
                return (
                  <RecordItem
                    key={item.id}
                    store={this.props.store}
                    data={item}
                  />
                )
              })
            }
          </RecordWrap>
        </HiddenScrollBar>
      </MaterialModal>
    )
  }
}

class RecordItem extends React.Component {
  renderRecordContent = () => {
    const { data } = this.props
    const { detailData } = this.props.store
    if (detailData.dataVersion === 'v1.0') {
      return (
        <RecordItemContent>
          {data.summary}
        </RecordItemContent>
      )
    } else if(detailData.dataVersion === 'v2.0') {
      return (
        <div>
          <RecordItemContent>
            性染色体：{data.summaryGender || '未见异常'}
          </RecordItemContent>
          <RecordItemContent>
            整倍体：{data.summaryAneu || '未见异常'}
          </RecordItemContent>
          <RecordItemContent>
            CNV: {data.summaryCNV || '未见异常'}
          </RecordItemContent>
          <RecordItemContent>
            补充结果: {data.summary || '无'}
          </RecordItemContent>
        </div>
      )
    }
  }
  render() {
    const { data } = this.props
    return (
      <RecordItemWrap>
        {this.renderRecordContent()}
        <InfoBar>
          <InfoArea>
            {data.send && (
              <Tag>已推送</Tag>
            )}
          </InfoArea>

          <RightArea>
            保存时间：{data.updateAt}
          </RightArea>
        </InfoBar>
        <Line />
      </RecordItemWrap>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/ReportDetail/PushModal.js